import React, { Component }  from 'react';
import '../../style.css';
import {Button, Card, message, Modal, Space, Table, Form, Tag, PageHeader, Spin, Menu, Dropdown} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {
 UploadOutlined ,
} from "@ant-design/icons";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
class IPUploadSupportPapers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IPA:[],
            IPB:[],
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            patentName:'',
            patentId:0,
            upload_A_visible:false,
            upload_B_visible:false,
            uploadFile_visible:false,
            delete_visible:false,
            fileField:[],
            checkStatus1:false,
            checkStatus2:false,
            checkStatus3:false,
            checkStatus4:false,
            checkStatus5:false,
            fileStream1:'',
            fileStream2:'',
            fileStream3:'',
            fileStream4:'',
            fileStream5:'',
            loading1:false,
            loading2:false,
            loading3:false,
            loading4:false,
            loading5:false,
            loadingUpload:false,
            fileChoose:'请选择文件类型',
            loadingPreview:false
        }
        this.hideModal = this.hideModal.bind(this);
        this.hideModalTwo = this.hideModalTwo.bind(this);
        this.fileInput = this.fileInput.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getPatentAccessA,{companyName:this.state.companyName})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            IPA:res.data,
                        }))
                    }
                }
            )
        fetchPost(global.constants.getPatentAccessB,{companyName:this.state.companyName})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            IPB:res.data,
                        }))
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            upload_A_visible:false,
            upload_B_visible:false,
            delete_visible:false,
            fileStream1:'',
            fileStream2:'',
            fileStream3:'',
            fileStream4:'',
            fileStream5:'',
            fileChoose:'请选择文件类型',
            checkStatus1:false,
            checkStatus2:false,
            checkStatus3:false,
            checkStatus4:false,
            checkStatus5:false,
            loading1:false,
            loading2:false,
            loading3:false,
            loading4:false,
            loading5:false,
        }))
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadAClick(e){
        const value = e.id;
        this.setState(()=>({
            upload_A_visible:true,
            patentId:value,
            patentName: e.patentName,
        }))
        let params1 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:value,
            otherId:0,
            remark:'证书',
            url:'',
        }
        fetchPost(global.constants.checkFile,params1)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus1:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus1:false,
                        }))
                    }
                })
        let params2 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:value,
            otherId:0,
            remark:'摘要',
            url:'',
        }
        fetchPost(global.constants.checkFile, params2)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus2:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus2:false,
                        }))
                    }
                })
        let params3 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:value,
            otherId:0,
            remark:'最近一次的缴费收据',
            url:'',
        }
        fetchPost(global.constants.checkFile, params3)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus3:true
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus3:false,
                        }))
                    }
                })
    }
    handleUploadBClick(e){
        const value = e.id;
        this.setState(()=>({
            upload_B_visible:true,
            patentId: value,
            patentName: e.patentName,
        }))
        let params1 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId: value,
            otherId:0,
            remark:'证书',
            url:'',
        }
        fetchPost(global.constants.checkFile, params1)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus1:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus1:false,
                        }))
                    }
                })
        let params2 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId: value,
            otherId:0,
            remark:'摘要',
            url:'',
        }
        fetchPost(global.constants.checkFile, params2)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus2:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus2:false,
                        }))
                    }
                })
        let params3 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId: value,
            otherId:0,
            remark:'最近一次的缴费收据',
            url:'',
        }
        fetchPost(global.constants.checkFile, params3)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus3:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus3:false,
                        }))
                    }
                })
        let params4 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId: value,
            otherId:0,
            remark:'受让-受赠协议',
            url:'',
        }
        fetchPost(global.constants.checkFile, params4)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus4:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus4:false,
                        }))
                    }
                })
        let params5 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId: value,
            otherId:0,
            remark:'专利权人变更手续合格通知书',
            url:'',
        }
        fetchPost(global.constants.checkFile, params5)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus5:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus5:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        this.setState(()=>({
            loadingUpload:true
        }))
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',this.state.patentId);
        formdata.append('otherId',0);
        formdata.append('remark',this.state.fileChoose);
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            this.setState(()=>({
                                fileField:[]
                            }))
                            if(this.state.fileChoose === '证书'){
                                this.setState(()=>({
                                    uploadFile_visible:false,
                                    checkStatus1:true,
                                    loadingUpload:false,
                                }))
                            }
                            if(this.state.fileChoose === '摘要'){
                                this.setState(()=>({
                                    uploadFile_visible:false,
                                    checkStatus2:true,
                                    loadingUpload:false,
                                }))
                            }
                            if(this.state.fileChoose === '最近一次的缴费收据'){
                                this.setState(()=>({
                                    uploadFile_visible:false,
                                    checkStatus3:true,
                                    loadingUpload:false,
                                }))
                            }
                            if(this.state.fileChoose === '受让-受赠协议'){
                                this.setState(()=>({
                                    uploadFile_visible:false,
                                    checkStatus4:true,
                                    loadingUpload:false,
                                }))
                            }
                            if(this.state.fileChoose === '专利权人变更手续合格通知书') {
                                this.setState(() => ({
                                    uploadFile_visible: false,
                                    checkStatus5: true,
                                    loadingUpload:false,
                                }))
                            }
                        }
                    })
        }
    }
    fileChange(e){
        this.setState(()=>({
            fileChoose:e,
            loading1:false,
            loading2:false,
            loading3:false,
            loading4:false,
            loading5:false,
        }))
    }
    preview(){
        this.setState(()=>({
            loadingPreview:true
        }))
        if(this.state.fileChoose === '证书') {
            if (this.state.checkStatus1) {
                let params = {
                    companyId: this.state.companyId,
                    projectId: 0,
                    productId: 0,
                    patentId: this.state.patentId,
                    otherId: 0,
                    remark: '证书',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile, params)
                    .then(
                        res => {
                            res.blob().then(
                                blob => {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(() => ({
                                        fileStream1: blobUrl,
                                        loading1: true,
                                        loadingPreview:false
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "摘要"){
            if (this.state.checkStatus2){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'摘要',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream2:blobUrl,
                                        loading2:true,
                                        loadingPreview:false
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "最近一次的缴费收据"){
            if (this.state.checkStatus3){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'最近一次的缴费收据',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream3:blobUrl,
                                        loading3:true,
                                        loadingPreview:false
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "受让-受赠协议"){
            if (this.state.checkStatus4){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'受让-受赠协议',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream4:blobUrl,
                                        loading4:true,
                                        loadingPreview:false
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "专利权人变更手续合格通知书"){
            if (this.state.checkStatus5){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'最近一次的缴费收据',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream5:blobUrl,
                                        loading5:true,
                                        loadingPreview:false
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
    }
    delete(){
        if(this.state.fileChoose === '证书') {
            if (this.state.checkStatus1) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'证书',
                    url: '',
                }
                fetchPost(global.constants.deleteFile,params)
                    .then(
                        res=>{
                            if(res.code === 200){
                                message.success("删除成功").then()
                                this.setState(()=>({
                                    checkStatus1:false,
                                    loading1:false
                                }))
                            }
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "摘要"){
            if (this.state.checkStatus2){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'摘要',
                    url: '',
                }
                fetchPost(global.constants.deleteFile,params)
                    .then(
                        res=>{
                            if(res.code === 200){
                                message.success("删除成功").then()
                                this.setState(()=>({
                                    checkStatus2:false,
                                    loading2:false
                                }))
                            }
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "最近一次的缴费收据"){
            if (this.state.checkStatus3){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'最近一次的缴费收据',
                    url: '',
                }
                fetchPost(global.constants.deleteFile,params)
                    .then(
                        res=>{
                            if(res.code === 200){
                                message.success("删除成功").then()
                                this.setState(()=>({
                                    checkStatus3:false,
                                    loading3:false
                                }))
                            }
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "受让-受赠协议"){
            if (this.state.checkStatus4){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'受让-受赠协议',
                    url: '',
                }
                fetchPost(global.constants.deleteFile,params)
                    .then(
                        res=>{
                            if(res.code === 200){
                                message.success("删除成功").then()
                                this.setState(()=>({
                                    checkStatus4:false,
                                    loading4:false
                                }))
                            }
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "专利权人变更手续合格通知书"){
            if (this.state.checkStatus5){
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:this.state.patentId,
                    otherId:0,
                    remark:'专利权人变更手续合格通知书',
                    url: '',
                }
                fetchPost(global.constants.deleteFile,params)
                    .then(
                        res=>{
                            if(res.code === 200){
                                message.success("删除成功").then()
                                this.setState(()=>({
                                    checkStatus5:false,
                                    loading5:false
                                }))
                            }
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
    }
    render() {
        const file_menu1 = (
            <Menu>
                <Menu.Item onClick={this.fileChange.bind(this,'证书')}>
                    证书
                    {this.state.checkStatus1 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'摘要')}>
                    摘要（选填）
                    {this.state.checkStatus2 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'最近一次的缴费收据')}>
                    最近一次的缴费收据
                    {this.state.checkStatus3 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
            </Menu>
        )
        const file_menu2 = (
            <Menu>
                <Menu.Item onClick={this.fileChange.bind(this,'证书')}>
                    证书
                    {this.state.checkStatus1 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'摘要')}>
                    摘要（选填）
                    {this.state.checkStatus2 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'最近一次的缴费收据')}>
                    最近一次的缴费收据
                    {this.state.checkStatus3 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'受让-受赠协议')}>
                    受让-受赠协议（选填）
                    {this.state.checkStatus4 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'专利权人变更手续合格通知书')}>
                    专利权人变更手续合格通知书（选填）
                    {this.state.checkStatus5 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
            </Menu>
        )
        return(
            <div>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="知识产权证明材料"
                        subTitle='只允许上传50M以内的pdf格式的文件'
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <div className = "content-header-area">
                        <span className="content-header">
                        知识产权（自主研发）证明材料
                        </span>
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IPA}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">知识产权名称</p>} dataIndex="patentName" key="patentName" />
                            <Column align="center" title={<p className="list-column-style">类别</p>} dataIndex="category" key="category" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}
                                            onClick={this.handleUploadAClick.bind(this,record)}
                                        >上传</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.upload_A_visible}
                    title={this.state.patentName}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'60%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        <Form>
                            <Form.Item name={'fileChoose'}>
                                <Dropdown overlay={file_menu1} placement="bottomCenter" arrow trigger='click'>
                                    <Button
                                        type="primary"
                                        style={{marginRight:5}}
                                    >{this.state.fileChoose}</Button>
                                </Dropdown>
                                <Button style={{marginRight:5}}  type={"primary"} onClick={this.preview.bind(this)}>预览</Button>
                                <Button type={"primary"} onClick={this.delete.bind(this)}>删除</Button>
                                {/*<Spin*/}
                                {/*    spinning={this.state.loading1||this.state.loading2||this.state.loading3}*/}
                                {/*    tip={"加载预览中"}/>*/}
                            </Form.Item>
                            {/*<Form.Item*/}
                            {/*    label={this.state.fileChoose}*/}
                            {/*    name={this.state.fileChoose}*/}
                            {/*    method="post"*/}
                            {/*    enctype="multipart/form-data"*/}
                            {/*>*/}
                                <input
                                    disabled={this.state.fileChoose === '请选择文件类型'}
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput}
                                />
                            {/*</Form.Item>*/}
                            <Form.Item name="preview_paper">
                                {
                                    this.state.loadingPreview === true &&
                                    <div style={{textAlign:'center'}}>
                                        <Spin tip={"加载预览中"}/>
                                    </div>
                                }
                                {
                                    this.state.loading1 === true &&
                                    this.state.fileChoose === '证书'&&
                                        <div>
                                            <FileViewer fileType='pdf'
                                                        filePath={this.state.fileStream1}
                                                        onError={this.onError}
                                            />
                                        </div>
                                }
                                {
                                    this.state.loading2 === true &&
                                    this.state.fileChoose === '摘要'&&
                                        <div>
                                            <FileViewer fileType='pdf'
                                                        filePath={this.state.fileStream2}
                                                        onError={this.onError}
                                            />
                                        </div>
                                }
                                {
                                    this.state.loading3 === true &&
                                    this.state.fileChoose === '最近一次的缴费收据'&&
                                        <div>
                                            <FileViewer fileType='pdf'
                                                        filePath={this.state.fileStream3}
                                                        onError={this.onError}
                                            />
                                        </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Space direction="vertical" className="content-style" >
                    <div className = "content-header-area">
                        <span className="content-header">
                        知识产权（受让、受赠、并购）证明材料
                        </span>
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IPB}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">知识产权名称</p>} dataIndex="patentName" key="patentName" />
                            <Column align="center" title={<p className="list-column-style">类别</p>} dataIndex="category" key="category" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}
                                            onClick={this.handleUploadBClick.bind(this,record)}
                                        >上传</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.upload_B_visible}
                    title={this.state.patentName}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'60%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        <Form>
                            <Form.Item name={'fileChoose'}>
                                <Dropdown overlay={file_menu2} placement="bottomCenter" arrow trigger='click'>
                                    <Button
                                        type="primary"
                                        style={{marginRight:5}}
                                    >{this.state.fileChoose}</Button>
                                </Dropdown>
                                <Button style={{marginRight:5}}  type={"primary"} onClick={this.preview.bind(this)}>预览</Button>
                                <Button type={"primary"} onClick={this.delete.bind(this)}>删除</Button>
                                {/*<Spin*/}
                                {/*    spinning={this.state.loading1||this.state.loading2||this.state.loading3||this.state.loading4||this.state.loading5}*/}
                                {/*    tip={"加载预览中"}/>*/}
                            </Form.Item>
                            {/*<Form.Item*/}
                            {/*    label={this.state.fileChoose}*/}
                            {/*    name={this.state.fileChoose}*/}
                            {/*    method="post"*/}
                            {/*    enctype="multipart/form-data"*/}
                            {/*>*/}
                                <input
                                    disabled={this.state.fileChoose === '请选择文件类型'}
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput}
                                />
                            {/*</Form.Item>*/}
                            <Form.Item name="preview_paper">
                                {
                                    this.state.loadingPreview === true &&
                                    <div style={{textAlign:'center'}}>
                                        <Spin tip={"加载预览中"}/>
                                    </div>
                                }
                                {
                                    this.state.loading1 === true &&
                                    this.state.fileChoose === '证书'&&
                                        <div>
                                            <FileViewer fileType='pdf'
                                                        filePath={this.state.fileStream1}
                                                        onError={this.onError}
                                            />
                                        </div>
                                }
                                {
                                    this.state.loading2 === true &&
                                    this.state.fileChoose === '摘要'&&
                                    <div>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream2}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                                {
                                    this.state.loading3 === true &&
                                    this.state.fileChoose === '最近一次的缴费收据'&&
                                    <div>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream3}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                                {
                                    this.state.loading4 === true &&
                                    this.state.fileChoose === '受让-受赠协议'&&
                                    <div>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream4}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                                {
                                    this.state.loading5 === true &&
                                    this.state.fileChoose === '专利权人变更手续合格通知书'&&
                                    <div>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream5}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.uploadFile_visible}
                    title={'上传'}
                    onCancel={this.hideModalTwo}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModalTwo}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.uploadFile}>
                            确定
                        </Button>,
                    ]}
                >
                    {
                        this.state.loadingUpload === true ?
                            <div style={{textAlign:'center'}}>
                            <Spin tip={"上传中"}/>
                            </div>:
                            <div>确定上传该{this.state.fileChoose}吗？</div>
                    }

                </Modal>
            </div>
        )
    }
}
export default IPUploadSupportPapers;